import script from "./MobileThumbnails.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileThumbnails.vue?vue&type=script&lang=ts&setup=true"

import "./MobileThumbnails.vue?vue&type=style&index=0&id=e594aa30&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e594aa30"]])

export default __exports__